exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.c-btn[data-v-cc0deba8] {\n  padding: 10px 20px;\n}\n.tab-flex[data-v-cc0deba8] {\n  margin: 20px 0px;\n  display: flex;\n  max-width: 1120px;\n}\n.ml-10[data-v-cc0deba8] {\n  margin-left: 10px;\n}\n.c-btn--back[data-v-cc0deba8] {\n  background-color: #e6e6e6;\n  color: #4b4b4b;\n}\n.bg-blue[data-v-cc0deba8]{\n  background: #34458D;\n}\n.page_block__top-container[data-v-cc0deba8]{\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  margin-right: 2rem;\n  margin-left: 2rem;\n}\n.mb-spacing[data-v-cc0deba8]{\n  margin-bottom: 48px;\n}\n", ""]);

// exports
